type OrientationListener = () => void;

const listeners = new Set<OrientationListener>();

const handleOrientationChange = () => {
    listeners.forEach((listener) => listener());
};

export const subscribeOrientation = (listener: OrientationListener) => {
    if (typeof window === "undefined") {
        return () => undefined;
    }

    if (listeners.size === 0) {
        window.addEventListener("orientationchange", handleOrientationChange);
    }

    listeners.add(listener);

    return () => {
        listeners.delete(listener);

        if (listeners.size === 0) {
            window.removeEventListener("orientationchange", handleOrientationChange);
        }
    };
};
